<template>
  <cvc-card
    :skeleton-type-matrix="[['chip', null, null], ['image']]"
    :skeleton-row-heights="[62, 460]"
    :failed="false"
    :loading="!data"
  >
<!--    <v-card-text class="d-flex pa-0">-->
      <v-container class="full-width">
        <v-row>
          <div class="advertising-estimator-action text-center font-size-medium-large">
            <cvc-acorn-trait-search
              v-model="selectedTraits"
            ></cvc-acorn-trait-search>
          </div>
          <div class="advertising-estimator-action text-center font-size-medium-large">
            <cvc-county-search
              v-model="counties"
            ></cvc-county-search>
          </div>
        </v-row>

        <v-row>
          <v-col cols="6">
            <v-row class="pa-3">
              <div class="info-box" style="height: 475px;">
                <span class="font-size-medium-large">
                  Segment Attributes
                </span>
                <div style="padding: 20px 0">
                  <v-chip-group column>
                    <v-chip
                      v-for="i in selectedTraits"
                      :key="'selected-trait-' + i"
                      close
                      @click:close="() => removeTrait(i)"
                    >
                      {{ getCvcTraitText(i) }}
                    </v-chip>
                    <v-chip
                      v-for="county in counties"
                      :key="'selected-county-' + county"
                      close
                      @click:close="() => removeCounty(county)"
                    >
                      {{ county }}
                    </v-chip>
                  </v-chip-group>
                </div>
              </div>
            </v-row>

            <v-row class="pa-3">
              <div class="info-box" style="height: 325px;">
                <span class="font-size-medium-large">
                  Total Estimated Reach
                </span>
                <div style="font-size: 4rem; line-height: 4rem; padding: 20px 0">
                  {{ totalAcornCodesFilteredByCountyAndTraits.toLocaleString() }}
                </div>
                <div>
                  Out of a total of
                  {{ totalPopulationCount.toLocaleString() }} that have consumed in
                  the last month.
                </div>
              </div>
            </v-row>
          </v-col>

          <v-col cols="6">
            <v-row class="pa-3">
              <div class="info-box" style="height: 750px;">
                <span class="font-size-medium-large">
                  Acorn Groups
                </span>
                <cvc-acorn-group-graph style="padding: 20px 0;"
                  :acorn-codes-total-population="acornCodesUnfiltered"
                  :acorn-codes-filtered-population="
                    acornCodesFilteredByCountyAndTraits
                  "
                ></cvc-acorn-group-graph>
              </div>
            </v-row>

            <v-row class="pa-3">
              <div class="d-block full-width">
                <v-dialog v-model="showCreateSegmentModal" width="500">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="cvc-button float-right"
                    width="270px"
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    Save Segment
                  </v-btn>
                </template>

                <v-card>
                  <v-card-title class="text-h5">
                    Save Segment
                  </v-card-title>
                  <v-card-text class="mt-2">
                    <v-form v-model="isSaveSegmentFormValid">
                      <v-row>
                        <div class="text--secondary font-size-medium mt-2 pr-2">
                          Name:
                        </div>
                        <v-text-field ref="nameField"
                          required
                          dense
                          single-line
                          class="profile-builder-name mt-1"
                          v-model="newSegmentName"
                          :rules="[
                            (x) => isAlphanumeric(x) || 'Profile name must be a-z, A-Z, 0-9 and spaces.',
                            (x) => !!x || 'Profile name is required',
                            (x) => x.length >= 3 || 'Profile name must be at least 3 characters',
                            (x) => activeSegmentNames.indexOf(x) === -1 || 'Segment name all ready exists.',
                          ]"
                        />
                      </v-row>

                      <v-row>
                        <div
                          class="text--secondary font-size-medium d-flex pr-2"
                          style="align-items: center"
                        >
                          Update Every:
                        </div>
                        <cvc-frequency-input
                          class="mt-2"
                          :show-icon="false"
                          v-model="newSegmentUpdateEvery"
                          :items="[
                            { text: 'weeks', value: 7 },
                            { text: 'days', value: 1 },
                          ]"
                        />
                      </v-row>

                      <v-row>
                        <div class="text--secondary font-size-medium pr-2">
                          Expiry:
                        </div>
                        <cvc-date-input
                          v-model="newSegmentExpires"
                          :clearable="false"
                        />
                      </v-row>

                      <v-row>
                        <div class="text--secondary font-size-medium mt-2 pr-2">
                          Description:
                        </div>
                        <v-textarea
                          dense rows="2"
                          single-line no-resize
                          class="profile-builder-name mt-1"
                          v-model="newSegmentDescription"
                          :rules="[
                            (x) =>
                              isAlphanumericOrWhitespace(x) ||
                              'Description must be of alphanumeric, fullstop or whitespace characters',
                          ]"
                        />
                      </v-row>
                      <!-- <v-row>
                        <pre>
                          {{ "\n" + JSON.stringify(profile, null, 2) + "\n" }}
                        </pre>
                      </v-row> -->
                      <!-- <v-text-field
                      placeholder="Segment name"
                      v-model="newSegmentName"
                      @keypress.enter="saveSegment"
                    ></v-text-field>
                    <v-text-field
                      placeholder="Segment "
                      v-model="newSegmentName"
                      @keypress.enter="saveSegment"
                    ></v-text-field> -->
                    </v-form>
                  </v-card-text>

                  <v-divider></v-divider>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        class="cvc-button text--white"
                        text
                        @click="saveSegment"
                        :disabled="!isSaveSegmentFormValid"
                        style="width: 200px"
                    >
                      Save
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              </div>
            </v-row>
          </v-col>
        </v-row>
      </v-container>

<!--    </v-card-text>-->

<!--      <v-row-->
<!--        class="height-25 mb-4 font-size-medium-large font-weight-medium"-->
<!--        style="margin-top: -4px"-->
<!--        no-gutters-->
<!--      >-->
<!--        Total Reach-->
<!--      </v-row>-->
<!--      <v-row style="font-size: 4rem" no-gutters>-->
<!--        {{ totalAcornCodesFilteredByCountyAndTraits.toLocaleString() }}-->
<!--      </v-row>-->
<!--      <v-row no-gutters>-->
<!--        Out of a total of-->
<!--        {{ totalPopulationCount.toLocaleString() }} that have consumed in-->
<!--        the last month.-->
<!--      </v-row>-->
  <!-- <v-row no-gutters>
      <cvc-card
        :skeleton-type-matrix="[['chip', null, null], ['image']]"
        :skeleton-row-heights="[62, 460]"
        :failed="false"
        :loading="false"
        class="mx-auto"
        title="Hey"
      >
        <v-row v-for="v in breakdown" :key="'breakdown-' + v[0]">
          {{ v[1] }} meet {{ v[0] }} criteria
        </v-row>
      </cvc-card>
    </v-row> -->
<!--    <v-row-->
<!--      class="height-25 mb-4 font-size-medium-large font-weight-medium"-->
<!--      style="margin-top: -4px"-->
<!--      no-gutters-->
<!--    >-->
<!--      Acorn Groups-->
<!--    </v-row>-->

  </cvc-card>
</template>

<script>
import CvcCard from "@/components/CvcCard";
import CvcAcornTraitSearch from "@/components/CvcFields/CvcAcornTraitSearch";
import CvcAcornGroupGraph from "@/components/CvcAcornGroupGraph.vue";
import { addMonths } from "date-fns";

import traits from "@/assets/traits.json";
import traitsAsTree from "@/assets/traits_as_tree.json";
import codes from "@/assets/codes.json";
import codesBySubjectThemeAndVariable from "@/assets/codes_by_subjecttheme_and_variable.json";
import { buildProfile } from "@/helpers/Cvcql";
import CvcCountySearch from "@/components/CvcFields/CvcCountySearch";
import CvcFrequencyInput from "@/components/CvcFields/CvcFrequencyInput";
import CvcDateInput from "@/components/CvcFields/CvcDateInput";
import {getRandomKebabCase, isAlphanumericOrWhitespace, isAlphanumeric} from "@/helpers/TextUtils";
import covaticVariableTextMapper from "@/assets/covatic_variable_text_mapper.json";

// TODO make these JSON, they do not need to be calculated fresh every time

Object.freeze(codes);
Object.freeze(codesBySubjectThemeAndVariable);

// function makeItemsAndFreeze(arrOfStrings) {
//   return Object.freeze(arrOfStrings.map((x, i) => ({ text: x, value: i })));
// }

export default {
  name: "AdvertisingEstimator",
  components: {
    CvcDateInput,
    CvcFrequencyInput,
    CvcCountySearch,
    CvcCard,
    CvcAcornTraitSearch,
    CvcAcornGroupGraph,
  },
  data() {
    return {
      isAlphanumeric,
      isAlphanumericOrWhitespace,
      traitsAsItems: Object.freeze(
        traits.map((x, i) => ({ text: x, value: i }))
      ),
      showCreateSegmentModal: false,
      showTraitsMenu: false,
      showCountiesMenu: false,
      traitsAsTree,
      traits,
      selectedThemeIndex: -1,
      selectedSubjectIndex: -1,
      selectedVariableIndex: -1,
      selectedTraits: [],

      // New segment data
      activeSegmentNames: [],
      newSegmentName: "",
      newSegmentUpdateEvery: 7,
      newSegmentExpires: addMonths(new Date(), 1).toISOString(),
      newSegmentDescription: "",
      isSaveSegmentFormValid: false,

      counties: [],
    };
  },
  mounted() {
    this.activeSegmentNames = this.$store.getters.nonDeletedProfiles.map(p => p.name);
  },
  methods: {
    saveSegment() {
      this.showCreateSegmentModal = false;
      this.$store.dispatch("postProfile", {data: this.profile}).then(() => {
        this.$toast.success(`Segment '${this.newSegmentName}' saved`);
        this.newSegmentName = "";
        this.newSegmentDescription = "";
        this.$router.push({name: 'AdvertisingSegments'});
      }).catch(err => {
        this.$toast.error(`Segment '${this.newSegmentName}' failed: ${err}`);
      });
    },
    getCvcTraitText(variableIndex) {
      // Maps the last part (the variable part) if it's in the custom covatic mappings.
      const textParts = traits[variableIndex].split(">");
      textParts[2] = covaticVariableTextMapper[variableIndex.toString()] ?? textParts[2];
      return textParts.join(">");
    },
    hideTraitsMenu() {
      this.showTraitsMenu = false;
    },
    removeTrait(i) {
      this.selectedTraits = this.selectedTraits.filter((x) => x !== i);
    },
    removeCounty(i) {
      this.counties = this.counties.filter((x) => x !== i);
    },
    getFilteredAcornCodes(filterCounties, filterAcornCodes) {
      const retval = {};
      for (let county of Object.keys(this.data)) {
        const acornCodes = this.data[county];

        // If the counties filter is false, skip this county
        if (!filterCounties(county)) continue;

        for (let acornCode of Object.keys(acornCodes)) {
          // If this acorn code filter is false, skip this acorn code
          if (!filterAcornCodes(acornCode)) continue;
          retval[acornCode] =
            (retval[acornCode] ?? 0) + (acornCodes[acornCode] ?? 0);
        }
      }

      return retval;
    },
  },
  computed: {
    data() {
      return this.$store.state.acornCodes.acornCodes ?? {}
    },
    profile() {
      let optionalAnnotations = {};
      if (this.newSegmentDescription) optionalAnnotations["insights/description"] = this.newSegmentDescription;

      return buildProfile(
        {
          and: [
            ...(this.selectedAcornCodes.length > 0
              ? [
                  {
                    or: this.selectedAcornCodes.map((x) => ({
                      acorn_code: { code: x },
                    })),
                  },
                ]
              : []),
            ...(this.counties.length > 0
              ? [{ or: this.counties.map((x) => ({ lives_in: { name: x } })) }]
              : []),
          ],
        },
        {
          name: getRandomKebabCase(this.newSegmentName, this.$store.getters.existingProfileIds),
          expires: this.newSegmentExpires + "T00:00:00+0000",
          update_every: this.newSegmentUpdateEvery,
          annotations: {
            "insights/display-name": this.newSegmentName,
            ...optionalAnnotations,
          }
        }
      );
    },
    acornCodesUnfiltered() {
      return this.getFilteredAcornCodes(
        () => true,
        () => true
      );
    },
    acornCodesFilteredByCounty() {
      return this.getFilteredAcornCodes(
        (county) =>
          this.counties.length === 0 || this.counties.includes(county),
        () => true
      );
    },
    acornCodesFilteredByCountyAndTraits() {
      return this.getFilteredAcornCodes(
        (county) =>
          this.counties.length === 0 || this.counties.includes(county),
        (acornCode) =>
          (this.counties.length !== 0 &&
            this.selectedAcornCodes.length === 0) ||
          this.selectedAcornCodes.includes(acornCode)
      );
    },
    totalAcornCodesFilteredByCountyAndTraits() {
      return Object.values(this.acornCodesFilteredByCountyAndTraits).reduce(
        (prev, curr) => prev + curr,
        0
      );
    },
    acornCodesWithActivatedTraits() {
      // This is the place that traits turn into acorn codes

      const subjectThemes = {};
      for (let t of this.selectedTraits) {
        t = traits[t];
        const subjectTheme = t
          .split(">")
          .splice(0, 2)
          .join(">");

        const variable = t.split(">")[2];

        if (!(subjectThemes[subjectTheme] instanceof Array)) {
          subjectThemes[subjectTheme] = [];
        }

        subjectThemes[subjectTheme].push(variable);
      }

      function checkAcornCodeHasTrait(subjectTheme, variable, acornCode) {
        return codesBySubjectThemeAndVariable[subjectTheme][variable].includes(
          acornCode
        );
      }

      // Now, for every acorn code we check if any variables are true within
      const retval = Object.fromEntries(
        [...Array(59).keys()].map((i) => [
          i + 1, // an acorn code
          Object.keys(subjectThemes).length === 0
            ? false
            : Object.keys(subjectThemes).every((st) => {
                // If any of the variables have the acorn code in this subjecttheme, return true (i.e. OR)
                for (let v of subjectThemes[st]) {
                  if (checkAcornCodeHasTrait(st, v, i + 1)) {
                    return true;
                  }
                }

                return false;
              }), // whether it's included or not
        ])
      );

      return retval;
    },
    selectedAcornCodes() {
      return Object.entries(this.acornCodesWithActivatedTraits)
        .filter((v) => v[1] === true)
        .map((v) => v[0]);
    },
    totalPopulationCount() {
      return Object.values(this.acornCodesUnfiltered).reduce(
        (prev, curr) => prev + curr,
        0
      );
    },
  },
};
</script>


<style scoped lang="scss">
  .advertising-estimator-action {
    display: flex;
    margin: 0 8px;
    background-color: #1F6ADA !important;
    min-height: 44px !important;
    height: 44px;
    width: 270px;
    border-radius: 0;
    text-transform: none !important;
  }
  .info-box {
    background-color: white;
    box-shadow: 1px 2px 2px #00000033;
    padding: 19px;
    width: 100%;
    height: 100%;
  }
  .counties-button {
    line-height: 44px;
    color: white !important;
    width: 100%;
    height: 100% !important;
    display: block;
    background: none !important;
    border: none !important;
    box-shadow: none !important;
  }
  .counties-menu {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    height: 60vh;
    background: #212121;
    z-index: 8;
  }
</style>